import { useState } from "react";

import { formatCents } from "@up/checkout";

import { ChangeDate } from "./ChangeDate";
import { LineItemConfirmDelete } from "./ConfirmDelete";

import { logError } from "@up/data";

import type { TLineItem } from "@up/data";

type Props = {
  item: TLineItem;
  removeFn: (_id: string) => Promise<unknown>;
};

export function LineItem({ item, removeFn }: Props) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [changeDate, setChangeDate] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleRemove = async function () {
    setIsDeleting(true);
    try {
      await removeFn(item._id);
    } catch (err) {
      logError({
        action: "CART_REMOVE_ITEM",
        error: err,
        context: { itemId: item._id },
      });
    } finally {
      setIsDeleting(false);
    }
  };

  const removeStep1 = function () {
    setChangeDate(false);
    setConfirmDelete(true);
  };

  return (
    <li
      className={`border border-solid transition-all ${
        confirmDelete
          ? "border-red-500 shadow-red-500 p-5 bg-red-50"
          : changeDate
            ? "border-blue-500 shadow-blue-500 p-5 bg-blue-50"
            : "border-gray-300 px-4 pt-4"
      }`}
      style={{
        boxShadow: confirmDelete
          ? "0 0 0 1px red"
          : changeDate
            ? "0 0 0 1px blue"
            : "",
      }}
    >
      <div className="text-base leading-tight opacity-70">
        {item.formattedStartDate} — {item.formattedEndDate}
      </div>
      <div className="text-lg font-bold leading-tight">
        {item.catalogueItem.name}
      </div>
      <div aria-hidden className="h-3" />
      <div className="flex flex-row justify-between">
        <span className="font-mono text-sm opacity-70">
          {item.cartDiscount?.discountedPrice != null &&
          item.cartDiscount.discountedPrice !== item.retailPrice ? (
            <>
              <s>{item.formattedRetailPrice}</s>{" "}
              <span className="font-bold not-italic">
                {formatCents(item.cartDiscount.discountedPrice)}
              </span>
            </>
          ) : (
            item.formattedRetailPrice
          )}
        </span>
      </div>
      <div className="flex flex-row justify-end">
        {!isDeleting && !confirmDelete && !changeDate ? (
          <button
            className="relative underline leading-none pb-4 pr-4 -right-4 text-sm"
            onClick={() => {
              setChangeDate(true);
            }}
          >
            change dates
          </button>
        ) : null}
        {!isDeleting && !confirmDelete && !changeDate ? (
          <button
            className="relative underline leading-none pb-4 pr-4 -right-4 text-sm"
            onClick={removeStep1}
          >
            remove
          </button>
        ) : null}
      </div>
      {changeDate ? (
        <ChangeDate
          cancel={() => {
            setChangeDate(false);
          }}
          catalogueItemId={item.catalogueItem._id}
          currentCohortId={item._id}
        />
      ) : null}
      {confirmDelete ? (
        <LineItemConfirmDelete
          cancel={() => {
            setConfirmDelete(false);
          }}
          confirm={handleRemove}
          isDeleting={isDeleting}
        />
      ) : null}
    </li>
  );
}
